jQuery(function($){
$(window).scroll(function() {
    // Code from websensepro.com
    //After scrolling 700px from the top...
    
  if($(window).width() > "1024"){
  if ( $(window).scrollTop() >= 500 ) {
    $('.sticky-bar').css('display', 'flex');

    //Otherwise remove inline styles and thereby revert to original stying
    } else {
    $('.sticky-bar').css('display', 'none');
    }
}});


$(window).scroll(function(){
//here we check the viewport width
if($(window).width() < "1024"){
//if the viewport width is less then 1024 scrolltop is 800
  if ($(window).scrollTop() >= 900) {
         $('.sticky-bar').css('display', 'flex');

    //Otherwise remove inline styles and thereby revert to original stying
    } else {
    $('.sticky-bar').css('display', 'none');
        
    }
}
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

var ellipsestext = "..";
	if( $('.seoDesc h2:first-child').length ) {
	   if ($('.seoDesc').height() > 200 ) {
  		$( "<div class='showMore'>Show more</div>" ).insertAfter( ".seoDesc" );
  		$(window).resize(function() {
      		var height = $(".seoDesc p:first-of-type").height();
      		var height2 = $(".seoDesc h2:first-of-type").height();
      		$(".seoDesc").css("height", height + height2 + 40 );
  		}).resize();
    		$(".seoDesc p:first-of-type").append("<span class='ellipseTxt'>" + ellipsestext + "</span>");
		}
	} else if ( $('.seoDesc p:first-child').length ) {

      if ($('.seoDesc').height() > 200 ) {
  		$( "<div class='showMore'>Show more</div>" ).insertAfter( ".seoDesc" );
  		$(window).resize(function() {
      		var height = $(".seoDesc p:first-of-type").height();
      		$(".seoDesc").css("height", height + 20 );
  		}).resize();
    		$(".seoDesc p:first-of-type").append("<span class='ellipseTxt'>" + ellipsestext + "</span>");
		}
    }

$(".showMore").on("click", function(){
		var $btn = $(".showMore");
		var $content = $(".seoDesc");
		$content.toggleClass("sized");

		if(($('.seoDesc.sized').length)){
    		$btn.text("Show less")
		} else {
        	$btn.text("Show more")
		}
});
  

function gridCountBig() {
    $('.big-screen #shopify-section-template--21625596281173__collection-grid .grid-compact').each(function() {
        var $list = $(this);
         if(!$('.more_less').length ) {
            $list.after('<button class="more_less button bigBtn">More</button>')
         } else if ($('.smallBtn.more_less').length ) {
            $( ".smallBtn.more_less" ).remove();
            $list.after('<button class="more_less button bigBtn">More</button>')
         }
      $list.find('.grid-item:gt(9)').show();
       $list.find('.grid-item:gt(29)').hide();
    });
}
function gridCountSmall() { 
  $('.small-screen #shopify-section-template--21625596281173__collection-grid .grid-compact').each(function() {
      var $list = $(this);
     if(!$('.more_less').length ) {
        $list.after('<button class="more_less button smallBtn">More</button>')
     } else if ($('.bigBtn.more_less').length ) {
            $( ".bigBtn.more_less" ).remove();
            $list.after('<button class="more_less button smallBtn">More</button>')
         }
     $list.find('.grid-item:gt(9)').hide();
  });
}
  
// Adds and removes body class depending on screen width.
function screenClass() {
    if($(window).innerWidth() > 750) {
        $('body').addClass('big-screen').removeClass('small-screen');
        gridCountBig();
    } else {
        $('body').addClass('small-screen').removeClass('big-screen');
        gridCountSmall();
    }
}

// Fire.
screenClass();
  
// And recheck when window gets resized.
$(window).bind('resize',function(){
    screenClass();
});
  
$(document).on('click', ".big-screen .bigBtn.more_less", function() {
        var $btn = $(this)
        $btn.prev().find('.grid-item:gt(29)').slideDown();    
        //$btn.text($btn.text() == 'More' ? 'See More' : 'More'); 
       $(this).replaceWith( "<button class='more_less button bigBtn'><a href='https://carmatiq.com/collections'>See More</a></button>" );
});
  
$(document).on('click', ".small-screen .smallBtn.more_less", function() {
      var $btn = $(this)
      $btn.prev().find('.grid-item:gt(9)').slideToggle();    
      //$btn.text($btn.text() == 'More' ? 'See More' : 'More');    
     $(this).replaceWith( "<button class='more_less button smallBtn'><a href='https://carmatiq.com/collections'>See More</a></button>" );
}); 
});